import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "src/pages/context/App.context";
import {checkEmpty, getNameProfile} from "src/service/util.service";
import * as GroupAPI from "../../../../service/group.service";
import {useLocation, useParams} from "react-router-dom"
import ChatGroup from "src/pages/chatPage/Content/Chat/ChatGroup";
//@ts-ignore
import _ from "lodash";
import ChatUserDetail from "src/pages/chatPage/Content/Chat/ChatUserDetail";
import ChatUserList from "src/pages/chatPage/Content/Chat/ChatUserList";
import {Col, Row} from "antd";
import ChatProvider, {ChatContext} from "src/pages/context/Chat.context";
import stylesChatContent from "../../../chatPage/Content/Chat/ChatContent.module.scss";
import StartToChat from "src/assets/png/StartToChat.png";
import {UserAPIEndpoint} from "src/service/user.service";
import useFetch, {CachePolicies} from "use-http";
import ModalRoleAssign from "src/pages/chatPage/Content/Chat/ModalRoleAssign";
import {useAppSelector} from "src/hooks";
import {profile} from "src/features/profile/profileSlice";

const GroupPrivacyLevel: any = {
  0: "PRIVATE",
  1: "CLOSE",
  2: "OPEN",
};

const ChatGroupCommunityContent = (props: any) => {
  const location = useLocation();
  const { id } = useParams();
  const appContext: any = useContext(AppContext);
  const myProfile = useAppSelector(profile);
  const [chat, setChat]: any = useState({});
  const [group, setGroup]: any = useState({});
  const chatCtx: any = useContext(ChatContext);
  const [nameProfile, setNameProfile] = useState("");
  const [usernameProfile, setUsernameProfile]: any = useState({});
  const [imgUrlProfile, setImgUrlProfile] = useState("");
  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });
  useEffect(() => {
    // setDataUser();
    appContext.setGroup(group);
    appContext.setNewChat(false);
    getGroup();
  }, []);

  const setDataUser = async () => {
    if (checkEmpty(appContext.profile)) {
      const me = await api.get(UserAPIEndpoint.Me);
      if (checkEmpty(me)) return;
      setUsernameProfile(me?.id);
      setNameProfile(
        getNameProfile(me?.firstname,me?.lastname)
      );
      setImgUrlProfile(me?.imageProfileURL);
      // appContext.setProfile({
      //   usernameProfile: me?.id,
      //   username: me?.username,
      //   nameProfile:
      //   getNameProfile(me?.firstname,me?.lastname),
      //   imgUrlProfile: me?.imageProfileURL,
      // });
    } else {
      setUsernameProfile(appContext.profile?.usernameProfile);
      setNameProfile(appContext.profile?.nameProfile);
      setImgUrlProfile(appContext.profile?.imgUrlProfile);
    }
  };

  const getGroup = async () => {
    // const queryString = new URLSearchParams(location?.search);
    // const id = queryString.get("id");
    const { data } = await GroupAPI.getGroupMemberInfo(id);

    setGroup(data);
    setChat(data);
  };

  const checkIsGroup = (privacyLevel: any) => {
    if (privacyLevel < 3) {
      return true;
    } else {
      return false;
    }
  };

  const getChatName = (group: any) => {
    let allMember =
      group.privacyLevel >= 3
        ? _.filter(group?.members, (data) => {
            if (data.user) {
              return data?.user?.id !== myProfile.id;
            }
          })
        : group?.members;

    let members = Object.assign([], _.slice(allMember, 0, 4));

    if (!members?.[0]) return null;

    let chatName = "chatName";
    if (GroupPrivacyLevel[group?.privacyLevel] && group?.name) {
      chatName = group.name;
    } else {
      chatName = getMemberName(members);
    }

    function getMemberName(members: any) {
      let memberName: any = [];
      _.each(members, (data: any) => {
        if (data?.user?.id !== props?.user) {
          memberName.push(data?.user?.id);
        }
      });
      return memberName.join(" ,");
    }
    return chatName;
  };

  const refreshGroupMember = async (groupId: string) => {
    try {
      const { data } = await GroupAPI.getGroupMemberInfo(groupId);
      setChat(data);
      setGroup(data);
      console.log(data);
      console.log("refreshGroup");
    } catch (error) {
      console.error();
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Row>
        {/* {`chat name : ${name}`}
  {`chat id : ${id}`} */}
        {/* <ChatContentTab onBackMainChat={()=>{}} isNewChat={false}></ChatContentTab> */}
        {/* <ChatContentTab
    onBackMainChat={() => {}}
    isNewChat={true}
    group={group}
    isQuickChat={false}
    isGroupCommunity={true}
  /> */}

        {/* {chatCtx.promoteMember !== null && (
          <RoleAssignPopup
            member={chat?.members}
            onPromoted={refreshGroupMember}
          />
        )} */}

        <ModalRoleAssign
          member={chat?.members}
          onPromoted={refreshGroupMember}
          context={chatCtx}
          visible={chatCtx.promoteMember !== null}
        />
        <Col
          className={stylesChatContent.boxMessageCommunity}
          style={{
            // marginLeft:
            //   chatCtx.showUserDetail || chatCtx.showUserList ? width : width * 2,
            width:
              chatCtx.showUserDetail || chatCtx.showUserList
                ? `calc(100% - 280px)`
                : `calc(100% - 0px)`,
          }}
        >
          {/* {(chatCtx.showUserDetail || chatCtx.showUserList) && (
            <div
              style={{ position: "relative" }}
              //  onClick={handleCloseUserDetail}
            >
              <div className={stylesChatContent.expandHistory}>
                <CaretRightOutlined
                  style={{ position: "absolute", top: "30%" }}
                />
              </div>
            </div>
          )} */}
          {!_.isEmpty(chat) ? (
            <ChatGroup
              id={chat?.id}
              name={chat?.name ? chat.name : getChatName(chat)}
              type={chat?.type}
              isGroup={checkIsGroup(chat?.privacyLevel)}
              coverImgURL={chat?.coverImgURL}
              imageID={chat?.imageID}
              privacyLevel={chat.privacyLevel}
              member={chat?.members}
              user={myProfile}
              clearChat={setChat}
              group={group}
              newChat={true}
              community
            />
          ) : (
            <div
              style={{
                backgroundImage: `url(${StartToChat})`,
                width: 191,
                height: 243,
                margin: "auto",
                marginTop: "20%",
                // marginBottom: "40%",
              }}
            ></div>
          )}
        </Col>
        {chatCtx.showUserDetail && (
          <Col>
            <ChatUserDetail />
          </Col>
        )}
        {chatCtx.showUserList && chat && chat.members && chat.id && (
          <Col>
            <ChatUserList
              members={chat?.members}
              chatId={chat?.id}
              // onLeave={refreshChatHistory}
              isGroup={checkIsGroup(chat?.privacyLevel)}
            />
          </Col>
        )}
      </Row>
    </div>
  );
};

const ChatGroupCommunity = (props: any) => {
  return (
    <ChatProvider>
      <ChatGroupCommunityContent />
    </ChatProvider>
  );
};

export default ChatGroupCommunity;
